import React from 'react'
import styles from './styles.css'
import Loading from 'App/components/RouteLoading'

export default class Landing extends React.Component {
  static propTypes = {}

  render() {
    window.location.pathname = '/accounts/mywallet'
    return (
      <div style={{backgroundColor: 'white'}}>
        <div className={styles.container}>
          <Loading />
        </div>
      </div>
    )
  }
}
